// PDF text extraction via pdfjs-dist. Lets users drop in an existing
// PDF resume; we extract the text and feed it through the same AI parse
// chain as paste-mode. Removes the copy-paste friction step.

import * as pdfjsLib from 'pdfjs-dist';

// pdfjs-dist v5 worker — load from CDN to avoid CRA's webpack worker-loader pain.
pdfjsLib.GlobalWorkerOptions.workerSrc =
    `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.mjs`;

export const extractTextFromPdf = async (file) => {
    if (!file) throw new Error('No file provided.');
    if (file.type && file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
        throw new Error('File is not a PDF.');
    }

    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

    const pageTexts = [];
    for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();

        // Reconstruct visual layout by grouping items into lines based on y-position.
        // Items come back with `transform` = [a, b, c, d, e, f]; f is y.
        const lineMap = new Map();
        for (const item of textContent.items) {
            if (!('str' in item)) continue;
            const y = Math.round(item.transform[5]);
            if (!lineMap.has(y)) lineMap.set(y, []);
            lineMap.get(y).push({ x: item.transform[4], str: item.str });
        }

        const sortedYs = Array.from(lineMap.keys()).sort((a, b) => b - a);
        const lines = sortedYs.map(y => {
            const lineItems = lineMap.get(y).sort((a, b) => a.x - b.x);
            return lineItems.map(it => it.str).join(' ').replace(/\s+/g, ' ').trim();
        }).filter(Boolean);

        pageTexts.push(lines.join('\n'));
    }

    return pageTexts.join('\n\n');
};
